import {combineReducers} from 'redux'
import AppReducer from 'redux/reducers/AppReducer'

import auctionReducer from 'redux/reducers/AuctionReducer'
import indicatorReducer from "redux/reducers/IndicatorReducer"
import UserReducer from 'redux/reducers/UserReducer'
import userReducer from "redux/reducers/UserReducer"

const rootReducer = combineReducers({
  authority: UserReducer,
  app: AppReducer,
  user: userReducer,
  // @ts-ignore
  auctions: auctionReducer,
  indicators: indicatorReducer
})

export default rootReducer
